import type { OrderQueryResult } from "@cheemspay/domain";

export interface AdminOrder {
  id: string; outTradeNo: string; userId: string; username: string | null;
  appId: string; productName: string; productCode: string; amountFen: number;
  orderStatus: string; fulfillmentStatus: string; createdAt: string;
  paidAt: string | null; fulfilledAt: string | null; refundPolicyCode: string;
}
export interface AdminOrderQuery {
  id: string; status: string; attempts: number; maxAttempts: number;
  lastError: string | null; runAt: string; createdAt: string; updatedAt: string;
  manual: boolean; result: OrderQueryResult | null;
}
export interface AdminOrderDetail {
  order: AdminOrder;
  queries: AdminOrderQuery[];
  payments: Array<{ id: string; providerTradeNo: string | null; status: string; paidAmountFen: number | null; paidAt: string | null }>;
  notifications: Array<{ id: string; tradeStatus: string | null; signatureValid: boolean; processingStatus: string; failureReason: string | null; createdAt: string }>;
  refunds: Array<{ id: string; status: string; amountFen: number; requestedAmountFen: number; reason: string; createdAt: string }>;
  grants: Array<{ id: string; status: string; resultingExpiry: string | null; createdAt: string }>;
  audit: Array<{ id: string; action: string; reason: string | null; createdAt: string }>;
}

export function adminStatus(value: string): string {
  return ({ CREATED: "已创建", PENDING_PAYMENT: "待支付", PAID: "已支付，待履约", FULFILLED: "已履约",
    CANCELLED: "已取消", REFUNDED: "已退款", MANUAL_REVIEW: "待人工核对", PENDING: "等待处理",
    RUNNING: "正在执行", DONE: "执行结束", DEAD: "执行失败", SUCCEEDED: "已完成", CLOSED: "已关闭",
    REVOKED: "已撤销", ACTIVE: "有效", APPLIED: "已发放", REVERSED: "已撤销", REFUND_REQUESTED: "已申请退款", SENT: "已发送", BOUNCED: "退信", OPEN: "待处理", RESOLVED: "已处理",
    TRADE_SUCCESS: "交易支付成功", TRADE_FINISHED: "交易结束", WAIT_BUYER_PAY: "等待买家付款", TRADE_CLOSED: "交易关闭",
  } as Record<string, string>)[value] ?? value;
}

export const queryOutcome: Record<OrderQueryResult["outcome"], { title: string; description: string; good?: boolean }> = {
  NOT_FOUND: { title: "支付宝未查到交易", description: "可能尚未打开收银台或交易尚未建立。本次没有修改订单或权益；不能据此认定用户未付款。" },
  WAITING: { title: "支付宝等待买家付款", description: "交易已建立，尚未支付。本次没有修改订单或权益。" },
  CLOSED: { title: "支付宝交易已关闭", description: "本地尚未支付的订单会标记为已关闭；已付款记录和权益不据此撤销，请结合退款记录核对。" },
  VERIFIED: { title: "支付与履约核对一致", description: "支付宝支付成功且金额与订单一致，本地已履约。本次没有重复发放权益。", good: true },
  FULFILLED: { title: "已确认支付并完成履约", description: "支付宝支付金额与订单一致，已按原订单内容通过现有履约流程处理。", good: true },
  AMOUNT_MISMATCH: { title: "支付金额与订单不一致", description: "本次没有修改订单或权益。请核对支付宝商户账单及交易号，确认原因后再处理。" },
  LOCAL_TERMINAL: { title: "支付宝有支付记录，本地订单已终止", description: "订单已退款、取消或权益已撤销，本次只读取支付记录，没有恢复权益。请结合退款记录核对。" },
  REVIEW_REQUIRED: { title: "需要人工核对", description: "当前交易状态或证据不足以自动处理，本次没有修改订单或权益。请结合支付宝商户账单核对。" },
};

export const yuan = (fen: number | null) => fen === null ? "未返回" : `¥${(fen / 100).toFixed(2)}`;
export const adminTime = (value: string | null) => value ? new Date(value).toLocaleString("zh-CN", { timeZone: "Asia/Shanghai" }) : "—";
export const queryActive = (query: { status: string } | undefined) => query?.status === "PENDING" || query?.status === "RUNNING";
